module.exports = __webpack_public_path__ + "static/img/main-banner.cc87423.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/main-banner.png
// module id = COCL
// module chunks = 0